import {PolicyComponent} from "./components/views/policy/policy.component.js";
import {MainComponent} from "./components/views/main/main.component.js";
import {FeedbackComponent} from "./components/shared/feedback/feedback.component.js";


export class Router {
    contentElement = document.getElementById('content');
    routes = [
        {
            route: '#/',
            title: 'Kafedra Agency | Фармацевтическое агенство',
            view: '/views/main.component.html',
            load: () => {
                new MainComponent();
            }
        },
        {
            route: '#/policy',
            title: 'Kafedra Agency: Политика конфиденциальности',
            view: '/views/policy.component.html',
            load: () => {
                new PolicyComponent();
            }
        },
    ];

    anchor = null;
    currentRoute = null;

    constructor() {
        this.init();
    }

    init() {
        window.addEventListener('DOMContentLoaded', this.openRoute.bind(this));
        window.addEventListener('popstate', this.handleRouteChanging.bind(this));
    }

    handleRouteChanging() {
        const currentRoute = location.hash;
        if (currentRoute !== this.currentRoute) { // Проверяем, что это действительно новый роут
            this.openRoute().then();
        }

        // Если открыть попап-feedback то закрываем
        if (FeedbackComponent.feedbackOpen) {
            FeedbackComponent.closeFeedback();
        }
    }

    async openRoute() {
        const [currentHash] = window.location.hash.split('?');

        if (/^#[a-zA-Z0-9_-]+(?:\s#[a-zA-Z0-9_-]+)*$/.test(currentHash)) {
            this.anchor = currentHash.substring(1);
        }

        const newRoute = this.routes.find(item => item.route === currentHash);

        if (!newRoute) {
            // Проверяем, что текущий роут не совпадает с тем, куда мы хотим перейти
            if (this.currentRoute !== '#/') {
                window.location.hash = '#/';
            }
            return;
        }

        // Проверяем, что новый роут отличается от текущего
        if (currentHash !== this.currentRoute) {
            this.currentRoute = currentHash; // Обновляем текущий роут
            await this.renderView(newRoute).then(() => {
                this.scrollToAnchor(this.anchor);
            });
        }
    }

    async renderView(route) {
        try {
            const response = await fetch(route.view);
            if (!response.ok) {
                this.errorOfView("Ошибка при загрузке страницы");
            }
            this.contentElement.innerHTML = await response.text();
            document.title = route.title;
            route?.load();
        } catch (error) {
            this.errorOfView(error);
        }
    }

    scrollToAnchor(anchorId = null) {
        const element = document.getElementById(anchorId);
        if (anchorId && element) {
            setTimeout(() => {
                element.scrollIntoView({ behavior: 'smooth' });
            }, 500)
            setTimeout(() => {
                this.anchor = null;
            }, 2000);
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    errorOfView(error) {
        window.location.hash = '#/';
        throw new Error(error)
    }
}